import { FULL_DECK } from "../appData/deck";
import { SPREADS } from "../appData/spreads/spreads.data";

export const getSpreadInitialState = (): ISpread => ({
  spreadMetadata: getEmptySpreadMetadata(),
  cards: [],
});

export const replaySpreadInitialState = (
  spreadId: number,
  cards: IRedrawCardInfo[],
  deck: ITarotCard[] = FULL_DECK
): ISpread => {
  const spreadIndex = SPREADS.findIndex((spread) => spread.id === spreadId);

  return {
    spreadMetadata: SPREADS[spreadIndex],
    cards: cards
      ? cards.map((card) => ({
          card: deck.find((deckCard) => deckCard.id === card.id)!,
          orientation: { reversed: card.re, flipped: true },
          position: {
            index: card.po,
            title: SPREADS[spreadIndex].positions.find(
              (position) => position.index === card.po
            )!.title,
          },
        }))
      : drawCardsForSpread(SPREADS[spreadIndex], deck),
  };
};

const getEmptySpreadMetadata = (): ISpreadMetadata => {
  return {
    id: 0,
    title: "",
    type: null,
    totalCards: 0,
    layout: null,
    positions: [],
    description: "",
  };
};

const generateUniqueRandomNumbers = (
  totalNumbers: number,
  rangeMax: number,
  rangeMin = 0
): Set<number> => {
  const uniqueRandomNumbers = new Set<number>();
  while (uniqueRandomNumbers.size < totalNumbers) {
    uniqueRandomNumbers.add(
      Math.floor(Math.random() * (rangeMax - rangeMin)) + rangeMin
    );
  }
  return uniqueRandomNumbers;
};

const getCardOrientation = (): ICardOrientation => {
  return {
    reversed: Math.floor(Math.random() * 100) >= 50,
    flipped: false,
  };
};

export const drawCardsForSpread = (
  spread: ISpreadMetadata,
  deck: ITarotCard[]
): ISpreadCard[] => {
  return Array.from(
    generateUniqueRandomNumbers(spread.totalCards, deck.length)
  ).map((randomNumber, i) => {
    return {
      position: spread.positions[i],
      card: deck[randomNumber],
      orientation: getCardOrientation(),
    };
  });
};
